/**
 * Store Équipes
 */
export default {
    state: {
        equipes: []
    },

    mutations: {
        /**
         * Initialise le state equipes
         */
        setEquipes: function (state, equipes) {
            state.equipes = equipes
        }
    },

    getters: {
        /**
         * Liste d'options d'équipes
         */
        optionsEquipes: state => {
            return state.equipes.map(equipe => {
                return {label: equipe.nom, value: equipe.id}
            })
        }
    }
}
